<template>
  <div class="binding-bd">
    <div class="pwd-wrap ubv">
      <div class="login-hd ub ub-sp ub-xc">
        <div class="header-l">
          <img class="logo" src="@/images/login/logo.png" alt />
        </div>
        <div class="header-r">
          <div class="lang">
            <el-dropdown>
              <span class="dropdown-lang el-dropdown-link">
                {{ activeWebsite }}-{{ activelanguage }}&ensp;
                <i class="icon icon-zhankai"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 210px; border-radius: 8px; padding: 10px 14px">
                <template v-for="(item, idx) in websiteList">
                  <el-dropdown-item :divided="index == 0 && idx !== 0" v-for="(value, index) in item.langList" :key="`${idx}-${index}`" @click.native="changeLanguage(item.domainUrl, value)">
                    <div class="ub">
                      <div class="ub-f1" style="height: 34px; line-height: 34px; font-weight: bold">
                        <span v-if="index == 0">{{ item.websiteName }}</span>
                      </div>
                      <div class="ub-f1" style="height: 34px; line-height: 34px">{{ value.localeName }}{{ index }}</div>
                    </div>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="wrap ub-f1">
        <div class="login-context ub">
          <div class="ub-f1 login-ad ub ub-xc ub-ac">
            <img style="width: 221px" src="@/images/login/find-pwd.png" alt="" />
          </div>
          <div class="ub-f1">
            <div class="login-box">
              <div class="title ub">
                <div class="ub-f1">
                  <h1>{{ loginLanguage.page_content_bind_login }}</h1>
                </div>
              </div>
              <div class="form">
                <div class="input-box ub ub-xc">
                  <div class="label">
                    <i class="icon icon-rengongmoshi"></i>
                  </div>
                  <input type="text" v-model="form.loginName" :placeholder="loginLanguage.placeholder_login_name" />
                  <div style="width: 16px"></div>
                </div>
                <div class="input-box ub ub-xc">
                  <div class="label">
                    <i class="icon icon-mima"></i>
                  </div>
                  <input :type="passwordShow ? 'text' : 'password'" v-model="form.loginPwd" :placeholder="loginLanguage.placeholder_login_pwd" />
                  <div class="yc">
                    <i class="icon" :class="[passwordShow ? 'icon-xianshi' : 'icon-yincang']" @click="passwordShow = !passwordShow"></i>
                  </div>
                </div>
                <p class="forword" @click="jump('/findpassword')">
                  <span>{{ loginLanguage.page_content_forget_pwd }}</span>
                </p>
                <div id="your-dom-id" class="nc-container"></div>
                <div class="btn" @click="bindLogin">
                  <span v-if="isLoading">{{ loginLanguage.page_content_logging }}</span>
                  <span v-else>{{ loginLanguage.page_content_bind_login }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bd">
        <div class="wraps ub ub-xc ub-sp">
          <div class="logo">
            <img src="@/images/login/logo-footer.png" alt="" />
          </div>
          <div class="copyright">
            <p>{{ loginLanguage.protal_login_uk_tip }}</p>
            <div>
              {{ loginLanguage.com_copyright }}
              <a href="http://beian.miit.gov.cn/" target="_blank">{{ loginLanguage.com_recordNumber }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoCaptcha from 'noCaptcha';
import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

export default {
  data() {
    return {
      websiteList: [],
      langType: [],
      activeWebsite: '',
      activelanguage: '',
      appId: '',
      form: {
        appCode: 'portal',
        loginName: '',
        loginPwd: '',
        userAuthId: '',
        sessionId: '',
        sig: '',
        ncToken: '',
        scene: '',
      },
      formValid: {
        loginName: { required: true, message: '请填写登录账号' },
        loginPwd: { required: true, message: '请填写登录账号' },
        sessionId: { required: true, message: '请按住滑块拖动到最右边' },
      },
      loginLanguage: {},
      passwordShow: false,
      isLoading: false,
    };
  },
  mounted() {
    this.getLangLogin();
    this.form.userAuthId = this.getJump('userAuthId');
  },
  methods: {
    // 获取站点和语言
    getLangLogin: function () {
      this.$getJSON(apis.DictionaryLangLogin, { websiteType: 2, websiteEnv: 1, domainUrl: window.location.origin }).then((res) => {
        this.websiteList = res.data.websiteList;
        this.langType = res.data.langType;
        const website = res.data.website || { websiteName: '未配置站', defaultLocale: 'CN' };
        const langCode = this.getJump('langCode') || Cookies.get('langCode') || website.defaultLocale;
        this.activeWebsite = website.websiteName;
        const langTypeValueName = this.$listTransObject(this.langType, 'value', 'name');
        this.activelanguage = langTypeValueName[langCode];
        Cookies.set('siteCode', website.websiteCode || '', { path: '/' }); // 记录站点Code
        Cookies.set('mapType', website.mapType || '', { path: '/' }); // 记录地图类型
        Cookies.set('mapRegion', website.mapRegion || '', { path: '/' }); // 记录地图区域
        Cookies.set('langCode', langCode, { path: '/' }); // 记录站点
        this.initLoginData(langCode.toLowerCase());
      });
    },
    // 获取多语言数据和滑块配置
    initLoginData: async function (langCode) {
      const [res1, res2] = await Promise.all([this.$getJSON(apis.NcConfig), this.$getJSON(apis.LanguageLogin, { langKeyCode: 'portal_cloud_login_page' })]);
      // 多语言
      this.loginLanguage = res2.data;
      this.formValid.loginName.message = this.loginLanguage.rule_tips_login_tips_1;
      this.formValid.loginPwd.message = this.loginLanguage.rule_tips_login_tips_2;
      this.formValid.sessionId.message = this.loginLanguage.rule_tips_login_tips_3;
      // 配置
      this.appId = res1.data.appId;
      this.form.scene = res1.data.scene;
      this.initSlide(Object.assign({ language: langCode }, res1.data));
    },
    // 初始化滑块
    initSlide: function (param) {
      const _this = this;
      this.form.ncToken = ['CF_APP_1', new Date().getTime(), Math.random()].join(':');
      const ncOpt = {
        // 声明滑动验证需要渲染的目标元素ID。
        renderTo: '#your-dom-id',
        // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: param.appKey,
        // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: param.scene,
        // 滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
        token: this.form.ncToken,
        // 滑动条的宽度。
        customWidth: 311,
        // 业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
        trans: { key1: 'code0' },
        // 通过Dom的ID属性自动填写trans业务键，可为空。建议您按照线上问题定位文档中推荐的方法配置该字段值。
        elementID: ['usernameID'],
        // 是否自定义配置底层采集组件。如无特殊场景，请使用默认值（0），即不自定义配置底层采集组件。
        is_Opt: 0,
        // 语言。PC端Web页面场景默认支持18国语言，详细配置方法请参见自定义文案与多语言文档。
        language: param.language,
        // 是否启用。一般情况，保持默认值（true）即可。
        isEnabled: true,
        // 内部网络请求的超时时间。一般情况建议保持默认值（3000ms）。
        timeout: 3000,
        // 允许服务器超时重复次数，默认5次。超过重复次数后将触发报错。
        times: 5,
        // 用于自定义滑动验证各项请求的接口地址。一般情况，请勿配置该参数。
        // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        callback: function (data) {
          _this.form.sessionId = data.csessionid;
          _this.form.sig = data.sig;
          _this.form.ncToken = data.token;
        },
      };
      const nc = new NoCaptcha(ncOpt);
      // 用于自定义文案。详细配置方法请参见自定义文案与多语言文档。
      nc.upLang(param.language, {
        _startTEXT: this.loginLanguage.page_content_slider_tips,
        _yesTEXT: this.loginLanguage.page_content_slider_verify_pass,
        _error300: this.loginLanguage.page_content_error300,
        _errorNetwork: this.loginLanguage.page_content_error_network,
      });
    },
    // 绑定登录
    bindLogin: async function () {
      if (this.isLoading) {
        return;
      }
      const result = await this.$validator(this.formValid, this.form);
      if (result) {
        this.$message.error(result[0].message);
        return;
      }
      this.isLoading = true;
      this.$postJSON(apis.BindUser, this.form)
        .then((res) => {
          this.isLoading = false;
          const timeOut = Number(moment(Date.now()).format('X')) + res.data.token.expiresIn;
          Cookies.set('token', res.data.token.accessToken, { path: '/' });
          Cookies.set('tokenTimeOut', timeOut, { path: '/' });
          Cookies.set('nonMetric', res.data.nonMetric, { path: '/' });
          Cookies.set('langCode', res.data.userInfo.langCode || 'CN', { path: '/' }); // 记录站点
          this.$store.commit('USERINFO', Object.assign({ timeZoneName: res.data.timeZoneName, timeZone: res.data.timeZone }, res.data.userInfo));
          this.$store.commit('TIMEZONE', res.data.timeZone);
          this.$store.commit('TIMEZONEID', res.data.timeZoneId);
          this.$store.commit('DATEFORMAT', res.data.dateFormat);
          this.$store.commit('ISTIME24H', res.data.isTime24h);
          this.jump('/');
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.binding-bd1 {
  height: 100%;
  background: #28282a;

  .binding-box {
    width: 608px;
    border-radius: 6px;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    .login-form-box {
      width: 328px;
    }
    .img-box {
      width: 280px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(250, 250, 250, 1);
      img {
        display: inline-block;
        width: 164px;
        height: 154px;
      }
    }
    .input-info {
      height: 40px;
      line-height: 40px;
      background-color: #f5f5f5;
      padding: 0 14px;
      font-weight: bold;
      color: #757575;
      font-size: 12px;
      margin-bottom: 16px;
    }
  }
}

.binding-bd {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 568px;
    background-color: #00a0d9;
  }
  .pwd-wrap {
    z-index: 10;
    height: 100%;
    position: relative;
    .wrap {
      width: 1280px;
      margin: 0 auto;
    }
    .login-hd {
      height: 88px;
      padding: 0 28px;
      .header-l {
        img {
          display: block;
          width: 180px;
        }
      }
      .header-r {
        .lang {
          cursor: pointer;
          height: 40px;
          min-width: 176px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          border-radius: 40px;
          padding: 0px 20px 0px 24px;
          .dropdown-lang {
            line-height: 38px;
            color: #ffffff;
            font-size: 14px;
          }
        }
        .lang-item {
          line-height: 82px !important;
        }
      }
    }
    .login-context {
      position: relative;
      overflow: visible;
      width: 750px;
      margin: 230px auto 0;
      border-radius: 16px;
      background-color: #ffffff;
      overflow: hidden;
      box-shadow: 0px 7px 23px rgba(0, 0, 0, 0.05);
      .login-ad {
        background: #f8f9fa;
      }
      .login-box {
        padding: 32px;
        .title {
          padding-bottom: 8px;
          h1 {
            color: #202945;
            font-weight: bold;
            font-size: 20px;
            line-height: 28px;
          }
          p {
            margin-top: 8px;
            font-size: 14px;
            color: #818181;
            line-height: 20px;
          }
        }
        .form {
          .input-box {
            height: 50px;
            margin-top: 24px;
            border: 1px solid #e6e6e6;
            border-radius: 8px;
            .label,
            .yc {
              width: 46px;
              cursor: pointer;
              text-align: center;
              .icon {
                font-size: 20px;
                color: #4d4d4d;
              }
            }
            input {
              flex: 1;
              font-size: 16px;
              height: 20px;
              border: none;
              outline: none;
            }
          }
          .forword {
            cursor: pointer;
            margin-top: 16px;
            text-align: right;
            height: 18px;
            font-size: 14px;
            color: #00a0d9;
          }
          .nc-container {
            margin-top: 25px;
            height: 48px;
            .nc_scale {
              height: 48px;
              background: #f5f5f5;
              border-radius: 100px;
              overflow: hidden;
              span {
                height: 48px;
                line-height: 48px;
              }
              .nc_iconfont {
                font-family: 'icon' !important;
                display: flex;
                font-size: 14px;
                &:after {
                  content: '\e818';
                  float: left;
                  margin-left: 10px;
                }
                &.btn {
                  color: transparent;
                }
                &.btn_ok:after {
                  content: '';
                  display: none;
                }
              }
              .btn_slide,
              .btn_ok {
                width: 60px;
                background: linear-gradient(90deg, #95d5ec 0%, #96d5ec 100%);
                border-top-right-radius: 100px;
                border-bottom-right-radius: 100px;
                border: none;
                text-align: center;
                color: #202945;
              }
              .nc_bg {
                width: 0;
                border-top-left-radius: 100px;
                border-bottom-left-radius: 100px;
                background: linear-gradient(90deg, #d0eaf3 0%, #95d5ec 100%);
                &:after {
                  content: '';
                  width: 48px;
                  height: 48px;
                  background-color: red;
                  transform: translateX(10px);
                }
              }
              .nc-lang-cnt {
                display: block;
                color: #202945;
                font-size: 14px;
              }
              .slidetounlock .nc-lang-cnt {
                transform: translateX(22px);
              }
            }
          }
          .btn {
            cursor: pointer;
            margin-top: 24px;
            height: 48px;
            line-height: 48px;
            background: #ffad00;
            border-radius: 100px;
            text-align: center;
            font-weight: bold;
            color: #202945;
          }
        }
      }
      .other-bar {
        margin-top: 37px;
        .bar {
          height: 1px;
          background-color: #e6e6e6;
          flex: 1;
        }
        p {
          color: #818181;
          font-size: 12px;
          padding: 0 20px;
        }
      }
      .other-way {
        margin-top: 15px;
        .way {
          padding: 0 16px;
          .icon {
            font-size: 40px;
          }
        }
      }
    }
  }
  .footer-bd {
    box-shadow: inset 0px 1px 0px #f0f0f0;
    padding: 0 28px;
    .wraps {
      height: 112px;
      line-height: 28px;
    }
    .logo img {
      display: block;
      width: 182px;
    }
    .copyright {
      font-size: 14px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.45);
      a {
        color: rgba(0, 0, 0, 0.45);
      }
      p {
        line-height: 30px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>
